import { Flex, Text } from "@chakra-ui/react";
import { useTab } from "../../contexts/useTab";

export default function DeviceManagerTabsHeader({
  title = "Quản lý thiết bị đăng nhập",
  rightSlot,
  onRefreshCurrentTab,
}) {
  const { activityTab, setActivityTab } = useTab();

  const tabs = [
    { title: "Thiết bị đăng nhập" },
    { title: "Yêu cầu đổi thiết bị" },
    // Chấm công luồng mới - Bước 1
    { title: "Đăng ký chấm công" },
    { title: "Đơn đổi thiết bị chấm công" },
    { title: "Lịch sử thiết bị chấm công" },
  ];

  const onClickTab = (idx) => {
    if (idx === activityTab) {
      onRefreshCurrentTab?.(); // => refresh
      return;
    }
    setActivityTab(idx);
  };

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center" gap={{ base: "74px" }}>
        <Text fontSize={{ base: "20px" }} fontWeight={600}>
          {title}
        </Text>

        <Flex gap={{ base: "8px 24px" }} flexWrap={"wrap"}>
          {tabs.map((t, index) => (
            <Flex
              key={index}
              onClick={() => onClickTab(index)}
              cursor="pointer"
              padding="12px 5px 0px 5px"
              zIndex="10"
            >
              <Text
                position="relative"
                paddingBottom="8px"
                _before={{
                  content: '""',
                  position: "absolute",
                  bottom: "-1px",
                  left: 0,
                  width: "100%",
                  height: { base: activityTab === index ? "3px" : "0" },
                  backgroundColor: "var(--color-secondary)",
                }}
                fontSize={{ base: "16px" }}
                fontWeight={600}
                color={
                  activityTab === index ? "var(--color-secondary)" : "#9D9D9D"
                }
                whiteSpace="nowrap"
              >
                {t.title}
              </Text>
            </Flex>
          ))}
        </Flex>
      </Flex>

      <Flex alignItems="center" gap="16px">
        {rightSlot}
      </Flex>
    </Flex>
  );
}
